'use es6';

import JitaContainer from '../containers/JitaContainer';
import { isJitaUser } from '../crm-legacy-global-containers/isJitaUser';
export const setupJitaContainer = (auth, ownerId) => {
  JitaContainer.set(isJitaUser(ownerId, auth));
};